// VIP/A/B/C tier styling tokens — inspired by user's design reference
// (Adviser Hub Elite-2026 visuals) but using beplan's cognac/walnut brand
// instead of fuchsia/violet.
//
// Usage:
//   const style = getCategoryStyle(contact);
//   <div style={{ borderLeft: `4px solid`, borderColor: style.solid }}>
//   <span className="..." style={style.pillStyle}>{style.label}</span>

export const CATEGORY_STYLES = {
  VIP: {
    id: "VIP",
    label: "VIP",
    symbol: "★",
    // Gold/champagne — VIP klient
    solid: "#D4A017",
    bg: "linear-gradient(135deg, #FBBF24 0%, #F59E0B 50%, #D97706 100%)",
    bgSoft: "linear-gradient(135deg, rgba(251,191,36,0.10) 0%, rgba(245,158,11,0.10) 100%)",
    ribbonGradient: "linear-gradient(135deg, #FCD34D 0%, #F59E0B 50%, #D97706 100%)",
    ring: "rgba(245,158,11,0.45)",
    ringStrong: "rgba(245,158,11,0.7)",
    text: "#92400E",
    softText: "#78350F",
    pillStyle: {
      background: "linear-gradient(135deg, #FCD34D 0%, #F59E0B 50%, #D97706 100%)",
      color: "#FFFFFF",
      boxShadow: "0 2px 6px rgba(245,158,11,0.30), inset 0 1px 0 rgba(255,255,255,0.3)",
    },
  },
  A: {
    id: "A",
    label: "A",
    symbol: "◆",
    // Platinum/silver — A klient
    solid: "#64748B",
    bg: "linear-gradient(135deg, #CBD5E1 0%, #94A3B8 50%, #64748B 100%)",
    bgSoft: "linear-gradient(135deg, rgba(148,163,184,0.10) 0%, rgba(100,116,139,0.10) 100%)",
    ribbonGradient: "linear-gradient(135deg, #E2E8F0 0%, #94A3B8 50%, #64748B 100%)",
    ring: "rgba(100,116,139,0.40)",
    ringStrong: "rgba(100,116,139,0.65)",
    text: "#334155",
    softText: "#475569",
    pillStyle: {
      background: "linear-gradient(135deg, #CBD5E1 0%, #94A3B8 50%, #64748B 100%)",
      color: "#FFFFFF",
      boxShadow: "0 2px 6px rgba(100,116,139,0.28), inset 0 1px 0 rgba(255,255,255,0.3)",
    },
  },
  B: {
    id: "B",
    label: "B",
    symbol: "●",
    // Bronze/cognac (matches our brand!) — B klient
    solid: "#C25934",
    bg: "linear-gradient(135deg, #FB923C 0%, #C25934 50%, #92400E 100%)",
    bgSoft: "linear-gradient(135deg, rgba(194,89,52,0.10) 0%, rgba(146,64,14,0.10) 100%)",
    ribbonGradient: "linear-gradient(135deg, #FCA876 0%, #C25934 50%, #7C2D12 100%)",
    ring: "rgba(194,89,52,0.40)",
    ringStrong: "rgba(194,89,52,0.65)",
    text: "#92400E",
    softText: "#7C2D12",
    pillStyle: {
      background: "linear-gradient(135deg, #FB923C 0%, #C25934 50%, #92400E 100%)",
      color: "#FFFFFF",
      boxShadow: "0 2px 6px rgba(194,89,52,0.28), inset 0 1px 0 rgba(255,255,255,0.3)",
    },
  },
  C: {
    id: "C",
    label: "C",
    symbol: "○",
    // Standard/plain
    solid: "#A3A3A3",
    bg: "linear-gradient(135deg, #E5E5E5 0%, #D4D4D4 50%, #A3A3A3 100%)",
    bgSoft: "linear-gradient(135deg, rgba(163,163,163,0.06) 0%, rgba(115,115,115,0.06) 100%)",
    ribbonGradient: "linear-gradient(135deg, #F5F5F5 0%, #D4D4D4 50%, #A3A3A3 100%)",
    ring: "rgba(163,163,163,0.30)",
    ringStrong: "rgba(163,163,163,0.55)",
    text: "#525252",
    softText: "#737373",
    pillStyle: {
      background: "var(--surface)",
      color: "#525252",
      boxShadow: "0 1px 2px rgba(0,0,0,0.04), inset 0 0 0 1px rgba(0,0,0,0.10)",
    },
  },
};

export const CATEGORY_LIST = ["VIP", "A", "B", "C"];

// Normalize various stored values to canonical tier key.
// Some legacy records may use lower-case or missing values.
export const normalizeCategory = (raw) => {
  if (!raw) return "C";
  const v = String(raw).trim().toUpperCase();
  if (v === "VIP" || v === "V") return "VIP";
  if (v === "A") return "A";
  if (v === "B") return "B";
  if (v === "C" || v === "") return "C";
  return "C";
};

export const getCategoryStyle = (contact) => {
  const key = normalizeCategory(contact?.category);
  return CATEGORY_STYLES[key] || CATEGORY_STYLES.C;
};
